/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:100%}.control[_ngcontent-%COMP%]{font-size:1rem;line-height:1;width:100%;margin-bottom:1.07142857rem}.control__header[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-bottom:.35714286rem;line-height:inherit}.control__header[_ngcontent-%COMP%]:after, .control__header[_ngcontent-%COMP%]:before{content:\" \";display:table}.control__header[_ngcontent-%COMP%]:after{clear:both}"];
export { styles as styles };
